import React from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

const NotFound = ({ history }) => [
  <Button key={2} color="primary" variant="outlined" onClick={() => history.push('/')}>
    Gå til forsiden
  </Button>,
];

NotFound.propTypes = {
  history: PropTypes.any.isRequired,
};

export default withRouter(NotFound);
